<template>
  <Layout>
    <PageHeader :title="title" :items="items" /> 
    <div class="row">
        <div class="col-lg-12 col-sm-12 mb-3">
          <div class="card p-4">
           <div class="row">
            <div class="col-12 text-center m-5">
              *Comming Soon
            </div>
          </div>     
          </div>
       </div>
    </div>
  </Layout>
</template>

<script>
import FacebookService from "@/helpers/facebook.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import Particle from "./particle.vue";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
// import { tableData } from "./dataAdvancedtable";

export default {
  page: {
    title: "Tools Facebook",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Particle },
  data() {
    return {
      loading: false,
      loading1: false,
      search: false,
      totalResult:'-',
      searchKey: "",
      searchKeyPost:"",
      searchResult: [],
      searchResultPost: [],
      tableData:[],
      checkedBulk: [],
      search:false,
      title: "Facebook",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Facebook",
          active: true
        }
      ],
      totalRows: 1,
      totalAccount:'',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
        { key: "id_facebook", thClass: 'd-none', tdClass: 'd-none'},
        { key: "user_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "picture", thClass: 'd-none', tdClass: 'd-none'},
        { key: "updated_at", thClass: 'd-none', tdClass: 'd-none'},
        { key: "name", thClass: 'd-none', tdClass: 'd-none'},
        { key: "account", sortable: true,  label: this.$t('facebook.account')},
        { key: "first_name", sortable: true,  label: 'First Name' },
        { key: "last_name", sortable: true,  label: 'Last Name' },
        { key: "friends", sortable: true,  label: this.$t('facebook.facebook-friends') },
        { key: 'actions', class: 'text-center',  label: this.$t('facebook.action') }
      ]
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
      
    }
  },
  methods:{
        searchFacebook() {
        const data = {
            "nama": this.searchKey,
            "username":"aji.skmo",
            "follower":"1",
            "following":"1",
            "friend":"1"
        };
        if (this.searchKey != "") {
            this.search = true;    
            this.loading = true;
            this.searchResult = []
            FacebookService.search(data)
            .then((response) => {
                this.searchResult.push(response.data.output)
                this.totalResult = response.data.length
                this.loading = false;  
            })
            .catch((err) => {
                console.log(err);
                this.search = false;
                this.loading = false;  
            });
        }
        },
        
        searchPostFB() {
        const data = {
            "post_id": this.searchKeyPost,
        };
        console.log(data);
        if (this.searchKeyPost != "") {
            this.search = true;    
            this.loading1 = true;
            this.searchResultPost = []
            FacebookService.getDetailPost(data)
            .then((response) => {
                this.searchResultPost.push(response.data.output)
                this.totalResult = response.data.length
                this.loading1 = false;  
                console.log(response);
            })
            .catch((err) => {
                console.log(err);
                this.search = false;
                this.loading1 = false;  
            });
        }
        },

        listFacebook(){
          SocmedService.getAllFacebook()
          .then(response => {
                    this.tableData = []
                    this.totalAccount = response.data.data.length;
                    response.data.data.forEach(val => {
                        const data = {    
                        "id_facebook" : val.id_facebook,
                        "user_id" : val.user_id,
                        "account" : val.account,
                        "name" : val.name,
                        "picture" : val.picture,
                        "first_name" : val.first_name,
                        "last_name" : val.last_name,
                        "friends" : val.friends,
                        "join_at" : val.join_at,
                        "created_at" : this.formatDate(val.created_at),
                        "updated_at" : this.formatDate(val.updated_at),
                        }
                        this.tableData.push(data);
                    });
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // addInstagram(username){
        //     Swal.fire({
        //     title: this.$t('alert.alert-add')+username+' ?',
        //     showCancelButton: true,
        //     confirmButtonText: 'Save',
        //     confirmButtonColor: "#0067AC",
        //     }).then((result) => {
        //     if (result.isConfirmed) { 
        //     this.loading = true
        //       var data ={
        //         "nama": username
        //       }
        //       FacebookService.getUsername(data)
        //           .then( response => {
        //           var data_akun = response.data.output;
        //           this.saveInstagram(data_akun)
        //           console.log(response.data.output)
        //         })
        //         .catch(err => {
        //         console.log(err);
        //     });
        //     } 
        //     })
        // },
        // saveInstagram(data){
        //     //  Swal.showLoading()
        //         var data_ig = {
        //         "account" : data.username,
        //         "user_id" : data.pk,
        //         "full_name" : data.full_name,
        //         "bio" : data.biography,
        //         "followed_by" : data.following_count,
        //         "follows" : data.follower_count,
        //         "media" : data.media_count,
        //         "picture" : data.profile_pic_url,
        //         "website" : data.external_url,
        //         "join_at" : "0000-00-00"
        //     };
        //       SocmedService.createInstagram(data_ig)
        //             .then( response => {
        //                 if (response.status == 212) {    
        //                     Swal.fire('Instagram is Updated','', 'success');
        //                 } else {
        //                     Swal.fire(this.$t('alert.alert-save'), '', 'success') 
        //                 }    
        //                 this.loading = false
        //                 this.searchResult = "",
        //                 this.searchKey ="",
        //                 this.$router.push('/instagram') 
        //                 this.listInstagram();         
        //         })
        //         .catch(err => {
        //         console.log(err);
        //     });
        // },
        delFacebook(id){
              Swal.fire({
                  title: this.$t('button.delete.modal.confirmText[0]'),
                  text: this.$t('button.delete.modal.confirmText[1]'),
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: this.$t('button.cancel.text'),
                  confirmButtonText: this.$t('button.delete.text')
              }).then((result) => {
                  if (result.isConfirmed) {
                      SocmedService.deleteFacebook(id)
                      .then( response => {
                          this.listFacebook();
                          Swal.fire({
                              position: "top-end",
                              icon: "success",
                              title: this.$t('alert.alert-delete-facebook'),
                              showConfirmButton: false,
                              timer: 1500
                          });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
              });
        },
        // bulkAction(){
        //      Swal.fire({
        //           title: this.$t('button.delete.modal.confirmText[0]'),
        //           text: this.$t('button.delete.modal.confirmText[1]'),
        //           icon: "warning",
        //           showCancelButton: true,
        //           confirmButtonColor: "#34c38f",
        //           cancelButtonColor: "#f46a6a",
        //           cancelButtonText: this.$t('button.cancel.text'),
        //           confirmButtonText: this.$t('button.delete.text')
        //       }).then((result) => {
        //           if (result.isConfirmed) {
        //             var data = this.checkedBulk;
        //               SocmedService.deleteBulkInstagram(data)
        //               .then( response => {
        //                  this.checkedBulk = [];
        //                   this.listInstagram();
        //                   Swal.fire({
        //                       position: "top-end",
        //                       icon: "success",
        //                       title: this.$t('alert.alert-delete-facebook'),
        //                       showConfirmButton: false,
        //                       timer: 1500
        //                   });
        //               })
        //               .catch( err => {
        //                   console.log(err);
        //               });
        //           }
        //       });
        // },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
  mounted(){
    this.totalRows = this.items.length;
    this.listFacebook();
  }
};
</script>

<style scoped>
.loading{
  padding-top:20%;
  padding-bottom:20%;
}
</style>